import React from 'react';
import { Share2 } from 'lucide-react';
import Button from './Button';

interface ShareTriggerButtonProps {
  onClick: () => void;
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  children?: React.ReactNode;
}

const ShareTriggerButton: React.FC<ShareTriggerButtonProps> = ({
  onClick,
  variant = 'outline',
  size = 'md',
  className = '',
  children
}) => {
  return (
    <Button
      onClick={onClick}
      variant={variant}
      size={size}
      className={className}
    >
      <Share2 className="h-4 w-4 mr-2" />
      {children || 'Delen'}
    </Button>
  );
};

export default ShareTriggerButton;